// Save state to LocalStorage

export const saveState = (state, name) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(name, serializedState);
  } catch (err) {
    console.error('Error saving state:', err);
  }
};

// Load state from LocalStorage
export const loadState = name => {
  try {
    const serializedState = localStorage.getItem(name);
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (err) {
    console.error('Error loading state:', err);
    return undefined;
  }
};
